import React from 'react';
import { ChevronDown } from 'lucide-react';

export default function CollapsiblePanel({
  children,
  collapsedSummary,
  countBadge,
  expanded,
  icon: Icon,
  iconClassName,
  onToggle,
  title,
  titleClassName = 'text-gray-400 dark:text-gray-500',
  wrapperClassName = 'shrink-0',
  extraHeaderAction
}) {
  return (
    <div className={`bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm rounded-3xl ${wrapperClassName}`}>
      <div className={`w-full flex items-stretch p-3 hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors relative z-20 ${expanded ? 'rounded-t-3xl' : 'rounded-3xl'}`}>
        <button
          type="button"
          onClick={onToggle}
          className="flex min-w-0 flex-1 items-center justify-between text-left"
        >
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <div className={`h-8 w-8 rounded-full flex items-center justify-center ${iconClassName}`}>
              {Icon ? <Icon className="h-4 w-4" /> : null}
            </div>
            <div className="flex flex-col items-start min-w-0 flex-1">
              <span className={`text-[10px] font-black uppercase tracking-widest ${titleClassName}`}>{title}</span>
              {!expanded && collapsedSummary ? (
                <div className="w-full">
                  {collapsedSummary}
                </div>
              ) : null}
            </div>
          </div>

          <div className="flex items-center gap-3">
            {countBadge}
            <ChevronDown size={16} className={`text-gray-400 transition-transform duration-300 ${expanded ? 'rotate-180' : ''}`} />
          </div>
        </button>

        {extraHeaderAction ? (
          <div className="ml-3 flex shrink-0 items-center">
            {extraHeaderAction}
          </div>
        ) : null}
      </div>

      <div className={`overflow-hidden transition-all duration-300 rounded-b-3xl ${expanded ? 'opacity-100 flex flex-col min-h-0 flex-1' : 'max-h-0 opacity-0'}`}>
        {children}
      </div>
    </div>
  );
}
